import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { hideModal } from '../../actions/ModalActions';
import * as ModalTypes from './index'
import history from '../../history'

const MODAL_TYPES = {
    'view': ModalTypes.ModalView,
    'alert': ModalTypes.ModalAlert,
    'comment': ModalTypes.ModalReply
}

class ModalRoot extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: this.props.modalProps.open
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.modalProps.open !== this.props.modalProps.open) {
            this.setState({
                modalIsOpen: nextProps.modalProps.open
            })
        }
    }

    closeModal = () => {
        this.props.hideModal();
    }

    render() {
        if (!this.props.modalType) {
            return null
        }
        const SpecifiedModal = MODAL_TYPES[this.props.modalType]
        return (
            <Modal
                size="lg"
                centered
                show={this.state.modalIsOpen}
                onHide={this.closeModal}
            >
                <SpecifiedModal
                    history={history}
                    hideModal={this.closeModal}
                    {...this.props.modalProps}
                />
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.modal
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        hideModal: () => {
            dispatch(hideModal())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalRoot);
